const config = {
    X_SERVICE_PROVIDER: "sbremit-web-uat",
    API_HOST: 'https://obsmoana.com:9090/proxy?url=http://api-uat.sbremit.co.uk',
}

export default config;